module.exports = __webpack_public_path__ + "fonts/Roboto-Thin.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Roboto/Roboto-Thin.ttf
// module id = 3463
// module chunks = 0